import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserProfile from '../components/UserProfile';
import WithUserData from '../HOC/withUserData';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetPassword: false,
    };
  }
  componentWillMount() {
    const params = window.location.href.split('?');
    if (params.length > 1 && params[1] === 'resetPassword') {
      this.setState({ resetPassword: true });
    }
  }
  onIframeToggle = () => {
    window.open('https://my.epik.io/xwiki', '_blank');
  };
  render() {
    const { user } = this.props;
    const { resetPassword } = this.state;

    return (
      <div style={{ padding: '1rem', marginTop: 20 }}>
          <UserProfile
            toggleIframe={this.onIframeToggle}
            resetPassword={resetPassword}
            profile={user}
          />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(WithUserData(Profile));
